export { default as AnnotationOutlineIcon } from './AnnotationOutlineIcon';
